import React from 'react';
import { AsyncZipDownloadModal } from 'molo-shared';

import FileApi, { mapFileApiZipResponse } from '../../store/files/FileApi';

interface Props {
    show: boolean;
    shouldHide: Function;
    orderId: number;
}

const DownloadOrderImagesModal: React.FC<Props> = (props) => {
    const { shouldHide, show, orderId } = props;

    const prepareZip = React.useCallback(
        async (onProgress, pollOptions) => {
            const response = await FileApi.createOrderImageZip(orderId, onProgress, pollOptions);
            return mapFileApiZipResponse(response);
        },
        [orderId]
    );

    return (
        <AsyncZipDownloadModal
            show={show}
            onHide={() => shouldHide()}
            scopeLabel={`Order B2B${orderId}`}
            prepareZip={prepareZip}
            onCancelJob={FileApi.cancelPackZipJob}
        />
    );
};

export default DownloadOrderImagesModal;
